import UserAppContext from '../../hook/UserAppContext';
import './load.css';

const Load = () => {

      const {user} = UserAppContext()

      if(user.length !== 0) return 
      
      return (
            <div className="page_load">
                  <div className="load_inner">
                        <h1>
                              <span style={{animationDelay: '.1s'}}>L</span>
                              <span style={{animationDelay: '.2s'}}>o</span>
                              <span style={{animationDelay: '.3s'}}>a</span>
                              <span style={{animationDelay: '.4s'}}>d</span>
                              <span style={{animationDelay: '.5s'}}>i</span>
                              <span style={{animationDelay: '.6s'}}>n</span>
                              <span style={{animationDelay: '.7s'}}>g</span>
                              <span style={{animationDelay: '.8s'}}>.</span>
                              <span style={{animationDelay: '.9s'}}>.</span>
                              <span style={{animationDelay: '1s'}}>.</span>
                        </h1>
                  </div>
            </div>
      )
}

export default Load;